// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__3FZdQ","unreadBadge":"styles_unreadBadge__3BQam","modalContent":"styles_modalContent__2s7IV","modal":"styles_modal__3rT1g"};